const ICON_TRANSITION_DURATION = 200;
const ICON_SIZE = 26;
const PROGRESS_STROKE_WIDTH = 2;
const hotspotIconCls = "_086h16q8x96";
const speechStateCls = "_086sshdwru";
const speechProgressCls = "_086s1li7ll1";
const hotspotCls = "_086h155sm55";

export { ICON_SIZE, ICON_TRANSITION_DURATION, PROGRESS_STROKE_WIDTH, hotspotCls, hotspotIconCls, speechProgressCls, speechStateCls };
import "./SpeechSynthesisHotspot.style.linaria.module.css";
//# sourceMappingURL=SpeechSynthesisHotspot.style.js.map
